import Image from 'next/image'
import { FC } from 'react'

import { MobileMenuGroup, StackMenuGroup } from '@/sections/NavBar/MenuGroup'

const products = [
    {
        url: '/shipment-data-collection',
        label: 'Shipment data collection',
        img: (
            <Image
                width={87}
                height={60}
                src={`/illustrations/menu-tile-images/lune-nav-data-collection.png`}
                alt={''}
            />
        ),
    },
    {
        url: '/emissions-calculations',
        label: 'Emissions calculations',
        img: (
            <Image
                width={87}
                height={60}
                src={`/illustrations/menu-tile-images/stamp-embed-calcs.png`}
                alt={''}
            />
        ),
    },
    {
        url: '/analytics-reporting',
        label: 'Analytics & reporting',
        img: (
            <Image
                width={87}
                height={60}
                src={`/illustrations/menu-tile-images/lune-nav-analytics.png`}
                alt={''}
            />
        ),
    },
    {
        url: '/carbon-projects',
        label: 'Carbon projects',
        img: (
            <Image
                width={87}
                height={60}
                src={`/illustrations/menu-tile-images/stamp-carbon.png`}
                alt={''}
            />
        ),
    },
]

export const ProductDesktopMenu: FC = () => {
    return <StackMenuGroup items={products} width={400} />
}

export const ProductMobileMenu: FC<{ onClose: () => void }> = ({ onClose }) => {
    return <MobileMenuGroup items={products} onClose={onClose} />
}
